import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeHighlightedSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12 .24L4.21 4.37v9.26l3.12 1.65v8.68L12 21.5l4.67 2.46v-8.68l3.12-1.65V4.37zm3.33 21.48L12 19.97l-3.33 1.75v-5.73L12 17.76l3.33-1.77zm3.11-8.9L12 16.24l-6.44-3.42V5.18L12 1.76l6.44 3.42z" />
        <path d="M7.514 6.383v5.234L12 14l4.486-2.383V6.383L12 4z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeHighlightedSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsBadgeHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeHighlightedSmall;
